import { Component, Input } from '@angular/core'
import { RiskScore } from 'src/app/modules/risks/models/risks'

@Component({
  selector: 'app-risk-score-icon',
  templateUrl: './risk-score-icon.component.html',
  styleUrls: ['./risk-score-icon.component.scss'],
  standalone: true,
  imports: []
})
export class RiskScoreIconComponent {
  @Input() icon!: any
  riskScore = RiskScore
  constructor() {}
}
